import { useState } from "react";
import { toast } from "react-toastify";
import { ReactComponent as XIcon } from "../../assets/icons/close-icon.svg";
import axios from "axios";
import { api } from "../..";

const AddCadre = ({ showAddCadre, setShowAddCadre }) => {
  const [cadre, setCadre] = useState();
  const [errorMessage, setErrorMessage] = useState("");

  const addCadre = () => {
    api
      .post("/api/cadre", { title: cadre })
      .then((res) => {
        setCadre("");
        toast.success("Cadre Added Successfully!");
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error Processing Request, please try again");
      });
  };

  return (
    <div className="addChild__container">
      <div
        className="addUserForm__content--container"
        style={{ height: "100%", width: "100vw" }}
      >
        <div className="addState__form">
          <span className="form__heading-and-close--CTA">
            <p className="addUserForm__formheading">Add Cadre</p>
            <XIcon
              style={{ fill: "#F95959", cursor: "pointer" }}
              onClick={() => setShowAddCadre(!showAddCadre)}
            />
          </span>
          <label htmlFor="state" className="addUserForm__password--label">
            Cadre
          </label>
          <div className="addUserForm__password-and-icons">
            <input
              type="text"
              className={
                errorMessage ? "email--input" : "addChild__email--input"
              }
              id="state"
              autoComplete="off"
              onChange={(e) => setCadre(e.target.value)}
              value={cadre}
              style={{ width: "100%", marginTop: "1.5rem" }}
              required
              aria-describedby="uidnote"
            />
            {errorMessage && (
              <p
                style={{
                  color: "#F95959",
                  marginTop: "1rem",
                }}
              >
                User Type is Required
              </p>
            )}
          </div>
          <button
            className="addUserForm__submit--CTA"
            onClick={() => addCadre()}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCadre;
